<template>
    <div
        v-if="!hidden"
        class="lni-c-element-container lni-u-mt0"
        :class="this.class">
        <slot />
    </div>
</template>

<script>
import framework from '../../framework';

/**
 *  The x-element-container component.
 *  @module components/x-element-container
 */


/**
 * The x-element-container is a basic element-container.
 */

export default {
    name: 'x-element-container',
    mixins: [
        framework.mixins.abstractElement,
    ],
    props: {
        dataHidden: Boolean,
    },
    computed: {
        /**
         * Whether the element is hidden
         * @returns {boolean} the text string.
         */
        hidden() {
            return this.getAttribute('hidden', false);
        },
    },
};
</script>
<style lang="scss">
    @import
        "../../styles/settings",
        "element-container";
</style>



// WEBPACK FOOTER //
// source/components/x-element-container/x-element-container.vue